import "../../../../src/styles/main.css";
import TrytheDemo from "../../../../src/pages/express-embed-sdk/trydemo.md";
import EditingTool from "../../../../src/pages/express-embed-sdk/editing-tools.md";
import LearnMore from "../../../../src/pages/express-embed-sdk/learn-more.md";
import EditImageTable from "../../../../src/pages/express-embed-sdk/edit-photo.md";
import EditVideoTable from "../../../../src/pages/express-embed-sdk/edit-video.md";
import bgImg from "../../../../src/pages/images/Summary_BgImage.jpg";
import DesignForDeveloper from "../../../../src/pages/express-embed-sdk/design-for-develop.md";
import MobileEditPhoto from "../../../../src/pages/express-embed-sdk/mobile-edit-photo.md";
import MobileEditVideo from "../../../../src/pages/express-embed-sdk/mobile-edit-video.md";
import * as React from 'react';
export default {
  TrytheDemo,
  EditingTool,
  LearnMore,
  EditImageTable,
  EditVideoTable,
  bgImg,
  DesignForDeveloper,
  MobileEditPhoto,
  MobileEditVideo,
  React
};